module.exports = __webpack_public_path__ + "img/product_56.9f0d235.webp";